import Debug from 'debug';
import { User } from '../models/User';
import { Trial } from '../models/Trial';
import { TrialData, UserData } from '../../types/api';
import { PollingService } from './PollingService';
import { userService } from './UserService';

/**
 * Poll the user & trial APIs periodically
 */
export class UserPollingService extends PollingService {
  protected debug = Debug('o365:UserPollingService');

  protected async doPoll(): Promise<boolean> {
    this.debug('doPoll()');

    const promises: Promise<unknown>[] = [userService.getUserDetails(), userService.getTrialDetails()];

    const [user, trial] = await Promise.all(promises);

    if (user) {
      const userModel = new User(user as UserData);
      const valid = userModel.validate();

      // if the user is not in a trial or does not have a closed account
      // only poll via long polling
      if (valid && userModel.get('inTrial') === false && userModel.get('subscriptionStatus') !== 'CLOSED') {
        this.debug('Updated polling to long');
        this.pollingMode = 'long';
      }

      userService.setUser(valid ? userModel : null);
    } else {
      userService.setUser(null);
    }

    userService.setTrial(trial ? new Trial(trial as TrialData) : null);

    return true;
  }
}

export const userPolling = new UserPollingService();
